/**
 * Konfiguration für den Site-Banner
 * 
 * enabled: Aktiviert/Deaktiviert den Banner global
 * text: Der anzuzeigende Text im Banner
 * boldText: Der fett geschriebene Teil am Anfang (z.B. "Neu:")
 * linkUrl: Die Ziel-URL des Links
 * backgroundColor: Die Hintergrundfarbe des Banners (Tailwind-Klasse)
 * textColor: Die Textfarbe des Banners (Tailwind-Klasse)
 * storageKey: Der Schlüssel, unter dem die Banner-Einstellung im localStorage gespeichert wird
 */

const bannerConfig = {
  enabled: false,
  text: "Entdecke unsere maßgeschneiderten E-Commerce Plattformen für B2B & B2C",
  boldText: "Neu:",
  linkUrl: "/e-commerce",
  backgroundColor: "bg-blue-600",
  textColor: "text-white",
  storageKey: "global-banner-hidden",
  // excludedPaths: ["/business-apps"] // Optionale Liste von Pfaden, auf denen der Banner nicht angezeigt werden soll
};

export default bannerConfig; 